<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <h3>Dostępne bębny</h3>
      <b-overlay :show="busy" rounded="sm">
        <div class="row">
          <div class="col-4 pb-3" v-for="item in barrels" :key="item.machineId">
            <b-card :header="item.name">
              <b-card-text>
                <div class="row">
                  <div class="col">
                    <div class="pb-3" v-if="item.coatingProducts.length > 0">
                      <span>
                        Aktualna mieszanka w bębnie:
                        <b>{{ item.coatingProducts[0].name }}</b> <br />
                        Dostępna waga kompozycji:
                        {{ item.coatingProducts[0].avaiableWeight }} kg
                      </span>
                      <span></span>
                    </div>
                    <div v-else>
                      Aktualna mieszanka w bębnie: Bęben jest pusty
                      <br />
                      Dostępna waga kompozycji: 0 kg
                    </div>
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div class="col" v-if="item.coatingProducts.length == 0">
                    <b-button :href="'#/oblewajProdukt/' + item.machineId" variant="primary"
                      class="grid-button-full">Stwórz produkt</b-button>
                  </div>
                  <div class="col" v-if="item.coatingProducts.length > 0">
                    <b-button block variant="primary" :href="'#/EdytujKompozycje/' + item.machineId">Edytuj
                      produkt</b-button>
                  </div>
                  <div class="col" v-if="item.coatingProducts.length > 0">
                    <b-button v-if="item.coatingProducts != undefined &&
                      item.coatingProducts.length == 1
                      " variant="primary" class="grid-button-full" @click="PutOnShelf(item)">Odłóż produkt na
                      półkę</b-button>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Common/Loading";
import axios from "axios";
import urlConfig from "../../mixins/url";
import toastr from "../../mixins/toastr";

export default {
  name: "DisplayBarrels",
  components: { Loading },
  mixins: [urlConfig, toastr],
  mounted() {
    this.GetBarrelsDetails();
  },
  data() {
    return {
      destinationCouvertureId: undefined,
      destinationCouvertureName: undefined,
      busy: false,
      barrels: [],
      isLoaded: false,
    };
  },
  methods: {
    PutOnShelf(barrelItem) {
      var that = this;
      var url = `${this.url.serverUrl}${this.url.Barrel.TakeOutCoatingProduct}`;
      axios.post(url, { barrelId: barrelItem.machineId }).then((res) => {
        if (res.data.success) {
          barrelItem.coatingProducts = [];
          barrelItem.composition = undefined;
        } else {
          that.DisplayError("Błąd!", res.data.errors[0]);
        }
      });
    },
    GetBarrelsDetails() {
      this.isLoaded = false;
      var url = this.url.serverUrl + this.url.Barrel.GetBarrelsDetails;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          that.barrels = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
        });
    },
    CreateCoatingProduct(barrelId) {
      this.busy = true;
      var url = this.url.serverUrl + this.url.Barrel.CreateCoatingProduct;
      var that = this;
      axios
        .post(url, { barrelId })
        .then(function (response) {
          if (response.data.success) {
            that.GetBarrelsDetails();
          } else {
            that.DisplayError("Błąd!", response.data.errors[0]);
          }
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
        })
        .finally(function () {
          that.busy = false;
        });
    },
  },
};
</script>
